import { Component, input } from '@angular/core';
import { StatusType } from '@core/interfaces';

@Component({
    selector: 'status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: false
})
export class StatusComponent {
    public type = input<StatusType>('default');

    public noWrap = input<boolean>(false);

    public tooltip = input<string>('');

    public mode = input<'simple' | 'complex'>('complex');
}
